import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=0e190e9e&"
import script from "./orderDetail.vue?vue&type=script&lang=ts&"
export * from "./orderDetail.vue?vue&type=script&lang=ts&"
import style0 from "./orderDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports